import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

// Season Progress is called Goals now and lives at /analytics/goals (22 Oct).
// Old links and bookmarks land there with what they asked for, `edit` included.
const searchSchema = z.object({
  edit: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/$orgPid/analytics/revenue')({
  validateSearch: searchSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({ to: '/$orgPid/analytics/goals', params, search });
  },
});
